// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/background1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/images/background2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/images/background3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/images/background4.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #102c97;
  display: flex;
  align-items: center;
  justify-content: end;
  z-index: 0;
}
.loginContainer .loginBg {
  width: 60%;
  height: 85%;
  display: flex;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  overflow: hidden;
  z-index: 1;
}
.loginContainer .loginBg .loginComp {
  width: 100%;
  height: 100%;
  position: relative;
}
.loginContainer .loginBg .loginComp img {
  position: absolute;
  top: 27%;
  right: 22%;
  width: 25rem;
  height: 25rem;
}
.loginContainer .loginBg .loginComp div {
  padding-right: 3rem;
  text-align: end;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  top: -3rem;
}
.loginContainer .loginBg .loginComp div h3 {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  line-height: 3rem;
  margin-top: 3.5rem;
}
.loginContainer .loginBg .loginComp div p {
  font-size: 1rem;
  font-weight: 400;
  color: white;
  line-height: 1.5rem;
  width: 80%;
  text-wrap: balance;
}
.loginContainer .loginBg .loginComp::after {
  content: "";
  position: absolute;
  z-index: -1;
  background-color: #102c97;
  mix-blend-mode: multiply;
  inset: 0;
}
.loginContainer .background-image-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.loginContainer .background-image-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.loginContainer .background-image-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.loginContainer .background-image-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.loginContainer .loginBg.slideOut {
  animation: slideOutLeft 0.8s cubic-bezier(0.29, 0.96, 0.2, 1.1) forwards;
}
.loginContainer .loginBg.slideIn {
  animation: slideInRight 0.8s cubic-bezier(0.29, 0.96, 0.2, 1.1) forwards;
}

@keyframes slideOutLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-200%);
  }
}
@keyframes slideInRight {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}
@media (max-width: 740px) {
  .loginContainer .loginBg {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Login/Background/BackGround.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AACJ;AAAI;EACI,UAAA;EACA,WAAA;EAGA,aAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAAR;AAGQ;EACI,WAAA;EACA,YAAA;EAEA,kBAAA;AAFZ;AAGY;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AADhB;AAGY;EACI,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AADhB;AAEgB;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAApB;AAEgB;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAApB;AAKQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EAEA,yBAAA;EACA,wBAAA;EACA,QAAA;AAJZ;AAOI;EACI,yDAAA;AALR;AAOI;EACI,yDAAA;AALR;AAOI;EACI,yDAAA;AALR;AAOI;EACI,yDAAA;AALR;AAQI;EACI,wEAAA;AANR;AASI;EACI,wEAAA;AAPR;;AAWA;EACI;IACE,wBAAA;EARJ;EAWE;IACE,4BAAA;EATJ;AACF;AAaE;EACE;IACE,2BAAA;EAXJ;EAcE;IACE,wBAAA;EAZJ;AACF;AAgBE;EAEM;IACE,aAAA;EAfR;AACF","sourcesContent":[".loginContainer {\n    width: 100%;\n    height: 100%;\n    overflow: hidden; \n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #102c97;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    z-index: 0;\n    .loginBg{\n        width: 60%;\n        height: 85%;\n        // width: 970px;\n        // height: 736px;    \n        display: flex;\n        background-size:contain;\n        background-position: center;\n        background-repeat: no-repeat;\n        position: absolute;\n        overflow: hidden;\n        z-index: 1;\n        // animation: leftSlide 1s ease-out forwards;\n        // animation: leftSlide .5 ease-out;\n        .loginComp{\n            width: 100%;\n            height: 100%;\n            // background-color: #102C97;\n            position: relative;\n            img{\n                position: absolute;\n                top: 27%;\n                right: 22%;\n                width: 25rem;\n                height: 25rem;\n            }\n            div{\n                padding-right: 3rem;\n                text-align: end;\n                display: flex;\n                flex-direction: column;\n                align-items: flex-end;\n                position: relative;\n                top: -3rem;\n                h3{\n                    font-size: 2.5rem;\n                    font-weight: 700;\n                    color: white;\n                    line-height: 3rem;\n                    margin-top: 3.5rem;\n                }\n                p{\n                    font-size: 1rem;\n                    font-weight: 400;\n                    color: white;\n                    line-height: 1.5rem;\n                    width: 80%;\n                    text-wrap: balance;\n                }\n                \n            }\n        }\n        .loginComp::after{\n            content: '';\n            position: absolute;\n            z-index: -1;\n            // background-color: #001b75;\n            background-color: #102c97;\n            mix-blend-mode: multiply;\n            inset: 0;\n        }\n    }\n    .background-image-1{\n        background-image: url('../../../assets/images/background1.svg');\n    }\n    .background-image-2{\n        background-image: url('../../../assets/images/background2.svg');\n    }\n    .background-image-3{\n        background-image: url('../../../assets/images/background3.svg');\n    }\n    .background-image-4{\n        background-image: url('../../../assets/images/background4.svg');\n    }\n    \n    .loginBg.slideOut {\n        animation: slideOutLeft 0.8s cubic-bezier(.29,.96,.2,1.1) forwards;\n    }\n    \n    .loginBg.slideIn {\n        animation: slideInRight 0.8s cubic-bezier(.29,.96,.2,1.1) forwards;\n    }\n    \n}\n@keyframes slideOutLeft {\n    0% {\n      transform: translateX(0);\n    //   opacity: 1;\n    }\n    100% {\n      transform: translateX(-200%);\n    //   opacity: 0;\n    }\n  }\n  \n  @keyframes slideInRight {\n    0% {\n      transform: translateX(100%);\n    //   opacity: 0;\n    }\n    100% {\n      transform: translateX(0);\n    //   opacity: 1;\n    }\n  }\n\n  @media (max-width:740px){\n    .loginContainer{\n        .loginBg{\n          display: none;\n        }\n      } \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
